export const ITALIAN_TRANSLATIONS = {
  text: {
    web_title: 'DASHBOARD SMARTZ™',
    authentication: 'Autenticazione',
    username: 'Nome utente',
    password: 'Password',
    sign_in: 'Accedi',
    username_required: 'Il nome utente è obbligatorio',
    password_required: 'La password è obbligatoria',
    invalid_credential: 'Nome utente o password non corretti',
    forgot_password: 'Password dimenticata',
    change: 'Cambia',
    well_being: 'Benessere',
    warnings: 'Avvertenze',
    no_patients_to_change: 'Nessun Paziente da modificare',
    no_patients: 'Nessun Paziente',
    logout: 'Esci',
    lost_connection: 'Connessione persa con il cloud Smartz™',
    check_connection: 'Controlla la connessione a Internet',
    trying_to_reconnect: 'Tentativo di riconnessione in corso',
    pad_time: 'Tempo nel pannolone',
    red_time: 'Tempo in rosso',
    position: 'Posizione',
    time: 'Ora',
    time_in_position: 'Tempo in posizione',
    sitting: 'Posizione seduta',
    standing: 'Posizione in piedi',
    left: 'Sinistra',
    right: 'Destra',
    lying: 'Posizione distesa',
    unknown: 'Sconosciuto',
    wet_surface: 'Superficie bagnata',
    out_of_range: 'Fuori intervallo',
    low_battery: 'Batteria in esaurimento',
    disconnected: 'Disconnesso',
    unexpected_problem: 'Problema imprevisto',
    ok: 'Ok',
    change_soon: 'Cambia presto',
    change_pad: 'Cambia pannolone',
    languages: 'Lingue',
    dashboard: 'DASHBOARD',
    pad_fill_profile: 'Profilo riempimento {pad}',
    goal: 'OBIETTIVI',
    report: 'RAPPORTO',
    manage: 'GESTISCI',
    individual: 'Privato',
    group: 'Gruppo',
    action_required: 'AZIONE RICHIESTA',
    monitor: 'MONITORA',
    pod_unclipped: 'modulo sganciato',
    check_patient: 'verifica {patient}',
    check_pad: 'verifica pannolone',
    check_time_in_pad: 'verifica tempo nel pannolone',
    check_position: 'verifica posizione',
    check_temperture: 'controlla temperatura',
    check_pad_fill_profile: 'VERIFICA PROFILO DI RIEMPIMENTO DEL {pad}',
    instructions: 'istruzioni',
    time_in_pos: 'tempo in pos',
    pad_capacity: 'capacità {pad}',
    time_in_pad: 'tempo nel pannolone',
    ambient: 'ambiente',
    time_at_temp: 'tempo alla temp',
    pad_wet: 'PANNOLONE BAGNATO',
    pad_dry: 'PANNOLONE ASCIUTTO',
    daily_pad_fill: 'Riempimento pannolone giornaliero',
    seven_day_trend: 'Andamento di sette giorni',
    daytime: 'Diurno',
    nighttime: 'Notturno',
    volume_in_pad: 'Volume nel pannolone',
    pad_fill_summary: 'RIEPILOGO RIEMPIMENTO PANNOLONE',
    daily_average: 'Media giornaliera',
    today: 'Oggi',
    capacity: 'Capacità',
    pads_used: 'pannoloni utilizzati',
    per_day: 'al giorno',
    average: 'media',
    leakage_detected: 'Perdita rilevata',
    times: 'volte',
    pad_cycles: 'Cicli di pannolone',
    time_in_a_pos: 'Tempo in una pos',
    max_time_in_a_pos: 'Tempo massimo in posizione',
    re_positioning: 'Riposizionamento',
    time_day: 'ora/giorno',
    temperature: 'Temperatura',
    typical_temp: 'Temperatura tipica',
    temp_range: 'Intervallo di temperatura',
    charts: 'GRAFICI',
    pad_fill_profile_for_7_days:
      'Profilo riempimento pannolone - Andamento sette giorni',
    daily_total: 'Totale giornaliero',
    accuracy: 'precisione',
    last_24_hours: '24 ore dalla data selezionata',
    volume_voided_in_pad: 'volume vuotato nel pannolone',
    body: 'Corpo',
    wetness_usage: 'bagnatura/utilizzo',
    environment_body: 'temperatura circostante',
    activity: 'Attività',
    lift_style: 'stile di sollevamento',
    skin_care: 'Cura della pelle',
    skin_care_management: 'gestione della cura della pelle',
    workflow: 'Flusso di lavoro',
    workflow_efficiency: 'efficienza del flusso di lavoro',
    set_maximum_voiding_volume_into_pad:
      'Stabilisci il volume massimo di vuotamento nel pannolone',
    less_void: 'MENO VUOTAMENTO',
    more_void: 'PIÙ VUOTAMENTO',
    day: 'GIORNO',
    night: 'NOTTE',
    day_time: 'Periodo diurno',
    night_time: 'Periodo notturno',
    average_period: 'Periodo medio',
    default: 'DEFAULT',
    desire_position: 'Tempo in posizione',
    time_in_a_position: 'Tempo in una posizione',
    desire_temperature: 'Temperatura modulo circostante',
    coloer: 'PIÙ FREDDA',
    hotter: 'PIÙ CALDA',
    desire_skin_care: 'Cura della pelle',
    off: 'SPENTO',
    standard_care: 'CURA STANDARD',
    extra_care: 'CURA EXTRA',
    more_time_in_wet_pad: 'PIÙ TEMPO NEL PANNOLONE BAGNATO',
    more_time_in_a_pos: 'PIÙ TEMPO IN UNA POS',
    less_time_in_wet_pad: 'MENO TEMPO NEL PANNOLONE BAGNATO',
    less_time_in_a_pos: 'MENO TEMPO IN UNA POS',
    override:
      'Questo obiettivo avrà la precedenza sugli obiettivi di pannolone e corpo',
    check_pod: 'verifica il modulo',
    check_pod_and_reclip: 'verifica il modulo e riaggancialo',
    lost_connect: 'Connessione persa',
    voids_into_pad_hours: 'Vuotamenti nel pannolone in 96 ore',
    chart_date: 'Data del grafico',
    fullscreen: 'Schermo intero',
    normalscreen: 'Schermo normale',
    void_chart: 'Grafico di svuotamento',
    voids_into_pad: 'vuotamenti nel pannolone',
    pad_fill_trend: 'andamento riempimento pannolone',
    legend: 'LEGENDA',
    new_pad: 'nuovo pannolone',
    void_in_pad: 'vuotamento nel pannolone',
    share: 'Condividi',
    print: 'Stampa',
    position_profile: 'Profilo delle posizioni',
    body_position: 'Posizione del corpo',
    body_positions_over_96_hours: 'Posizioni del corpo nel corso di 96 ore',
    lying_on_back: 'Posizione distesa - sulla schiena',
    lying_on_front: 'Posizione distesa - sulla pancia',
    lying_left_side: 'Posizione distesa - sul fianco sinistro',
    lying_right_side: 'Posizione distesa - sul fianco destro',
    standing_walking: 'Posizione in piedi/Camminata',
    stats: 'statistiche',
    pad_used: 'pannolone_utilizzato',
    max: 'max',
    surrounding_temperature: 'TEMPERATURA CIRCOSTANTE',
    temp: 'temp',
    avg: 'med',
    name: 'Nome',
    provider: 'Fornitore',
    purpose: 'Finalità',
    expiry: 'Scadenza',
    type: 'Tipo',
    frequently_asked_questions: 'Domande frequenti',
    information_for_use: `Informazioni per l'uso`,
    data_privacy: 'Riservatezza dei dati',
    eula: 'EULA',
    about: 'Chi siamo',
    settings: 'Impostazioni',
    save: 'Salva',
    version: 'versione',
    support: 'assistenza',
    close: 'Chiudi',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. Tutti i diritti riservati',
    smartz_devices: 'Dispositivi Smartz™',
    monitor_smartz_device_operation:
      'monitora il funzionamento del dispositivo Smartz™',
    last_seen: 'Ultima visualizzazione',
    battery: 'Batteria',
    ago: 'fa',
    date_rate: 'Intervallo date',
    online: 'Online',
    singnal: 'Segnale',
    temperature_goal: 'OBIETTIVO TEMPERATURA',
    data_privacy_desc: 'gestisci il consenso e i dati personali',
    organisation: 'ORGANIZZAZIONE',
    organisation_desc: 'gestisci le impostazioni di gruppo',
    my_account: 'Il mio account',
    my_account_desc: 'gestisici le impostazioni account',
    consent: 'Consenso',
    marketing_comm: 'Marketing, comunicazioni e promozioni',
    consent_desc: `I produttori e i distributori di pannoloni possono utilizzare i dati personali ai fini di marketing e promozioni. L'account utente associato a questo Paziente, se presente, può essere inviato tramite e-mail di volta in volta. In questo caso, l'email dell'utente potrebbe essere condivisa con terze parti.`,
    data_management: 'Gestione dei dati',
    Permanently_delete_account: 'Elimina questo account utente definitivamente',
    permanently_delete_client: 'Elimina questo cliente definitivamente',
    data_management_desc: `L'account non sarà più disponibile e tutti i dati al suo interno verranno eliminati definitivamente.`,
    how_can_i_export:
      'Come posso esportare ed eseguire il backup dei dati del mio account?',
    save_preference: 'SALVA LE PREFERENZE',
    delete_account_data: 'ELIMINA ACCOUNT E DATI',
    date_time_settings: 'Impostazioni data e ora',
    morning_time: 'Orario della mattina',
    night_time_label: 'Orario della notte',
    time_format: 'Formato ora',
    date_format: 'Formato Data',
    goal_text: 'obiettivo',
    day_goal: 'obiettivo giornaliero',
    night_goal: 'obiettivo notturno',
    productivity: 'Productività',
    productivity_goal: 'Obiettivo di produttività',
    score: 'Punteggio',
    presently: 'Attualmente',
    diapers_per_person: '{pads}/persona',
    diapers_per_person_daytime: '{pads}/persona/giorno',
    diapers_per_person_night: '{pads}/persona/notte',
    diapers_per_person_day: '{pads}/persona/giorno',
    check_battery: 'VERIFICA BATTERIA',
    reminders: 'promemoria',
    update_data_privacy_consent: 'Aggiorna il consenso alla privacy dei dati',
    update: 'Aggiorna',
    user: 'Utente',
    last_updated: 'Ultimo aggiornamento',
    action: 'Azione',
    delete_confirm: 'Vuoi eliminarlo?',
    cancel: 'Annulla',
    lost_internet_connection: 'CONNESSIONE A INTERNET PERSA',
    check_setting:
      'Controlla le impostazioni e le connessioni relative a Internet',
    authentication_required: 'Autenticazione richiesta',
    account_details_have_changed: `I dettagli dell'account sono cambiati`,
    date: 'Data',
    no_pod_assigned: 'nessun modulo assegnato',
    monitoring_is_not:
      'Il monitoraggio non è disponibile perché non è stato assegnato alcun modulo Smartz™ a ',
    assign_a_pod: 'Assegna un modulo a',
    on_the_smartz_monitor_app: `sull'app Smartz™ Monitoring per attivare il monitoraggio.`,
    see: 'Vedi',
    delete: 'cancella',
    keep_in_mind_delete_data: `Tieni presente che l'eliminazione dell'account utente e dei dati personali è permanente.`,
    you_able_to_delete_data: 'Stai per eliminare',
    account_and_data: 'account e dati',
    this: 'questo',
    average_time_in_pad: 'Tempo medio nel {pad}',
    average_time_in_position: 'Tempo medio in posizione',
    repositioning_24h: 'Riposizionamento 24 h',
    last_7_day_period: 'Ultimo periodo di 7 giorni',
    admin: 'AMMIN',
    administraive_settings: 'impostazioni amministrative',
    group_data_rentenion: 'Conservazione dei dati di gruppo',
    maximum_inactivity_data_retention_period:
      'Periodo massimo di conservazione dei dati di inattività',
    group_data_rentenion_desc: `I dati personali di tutti gli Utenti e {patients} all'interno di questo gruppo verranno rimossi se si raggiunge il periodo di inattività.`,
    data_rentenion_detail: `La condizione per l'inattività è la seguente:<br>- Il modulo non è assegnato al {patient} per il periodo di tempo specificato<br>- Il modulo è assegnato al {patient} ma non trasmette i dati alle app Smartz™ per il periodo di tempo specificato<br>- L'utente non ha effettuato l'accesso per il periodo di tempo specificato`,
    months: 'mesi',
    user_roles: 'Ruoli utente',
    users: 'Utenti',
    role: 'Ruolo',
    filter_by_group_or_users: 'filtra per gruppo o utenti',
    urine_conversion_feature: 'Funzione di conversione delle urine',
    use_urine_transform: 'Usa la trasformazione delle urine',
    system_data_rentenion: 'Conservazione dei dati di sistema',
    system_data_rentenion_desc: `I dati personali di tutti gli Utenti e {patients} all'interno di questo sistema verranno rimossi se si raggiunge il periodo di inattività.`,
    reset_password: 'Reimposta password',
    new_password: 'Nuova password',
    confirm_password: 'Conferma password',
    password_inconsistent: 'Le password non sono uguali',
    edit: 'modifica',
    edit_roles: 'Modifica ruoli',
    available_roles: 'Ruoli disponibili',
    assigned_roles: 'Ruoli assegnati',
    role_list: 'Elenco ruoli',
    role_name: 'Nome ruolo',
    role_permissions: 'Autorizzazioni ruolo',
    level_1_module: 'Modulo di livello 1',
    level_2_module: 'Modulo di livello 2',
    permissions: 'Autorizzazioni',
    add_role: 'AGGIUNGI RUOLO',
    roles: 'ruoli',
    role_settings: 'impostazioni ruolo',
    edit_role: 'Modifica ruolo',
    account_take_effect: `L'aggiornamento avrà effetto dopo il nuovo accesso.`,
    algorithms: 'Algoritmi',
    delete_role_confirm: 'La cancellazione del ruolo è permanente.',
    //translate permissions list
    'Dashboard Module': 'Modulo dashboard',
    'Charts Module': 'Modulo grafici',
    'Goals Module': 'Modulo obiettivi',
    'Manage Module': 'Gestisci modulo',
    Group: 'Gruppo',
    Individual: 'Individuo',
    'Voiding Chart': 'Grafico di svuotamento',
    'Pad Fill Profile Chart':
      'Grafico del profilo di riempimento del pannolone',
    'Body Position Chart': 'Grafico della posizione del corpo',
    'Smartz Devices Chart': 'Grafico dei dispositivi Smartz™',
    'Pad Fill Profile': 'Profilo riempimento pannolone',
    'Skin Care': 'Cura della pelle',
    Position: 'Posizione',
    Temperature: 'Temperatura',
    Admin: 'Amministratore',
    'My Account': 'Il mio account',
    Role: 'Ruolo',
    Organisation: 'Organizzazione',
    'Data Privacy': 'Riservatezza dei dati',
    View: 'Visualizza',
    Share: 'Condividi',
    Print: 'Stampa',
    Save: 'Salva',
    'Reset Password': 'Reimposta password',
    Delete: 'Elimina',
    Add: 'Aggiungi',
    Edit: 'Modifica',
    Fall: 'Caduta',
    //end translate permissions list
    check_fall: 'VERIFICA CADUTA',
    position_goal_not_allow_off:
      "L'obiettivo Posizione non può essere disattivato mentre l'obiettivo Cadute è attivo al fine di migliorare la sicurezza.",
    falls: 'Cadute',
    falls_detection_and_notification: 'rilevamento e notifica delle cadute',
    falls_detection: 'Rilevamento delle cadute',
    detect_falls: 'Rileva cadute',
    on: 'ON',
    position_goal: `L'obiettivo Posizione`,
    has_been_turn_on:
      'è stato attivato per integrare il rilevamento delle cadute e migliorare la sicurezza.',
    last_fall: 'Ultima caduta',
    last_week: 'settimana scorsa',
    three_months: '3 mesi',
    time_to_change: 'Ora del cambio',
    sent_successfully: 'Invio avvenuto correttamente',
    sent_failed: 'Invio non riuscito',
    send_email: 'Invia e-mail',
    send: 'Invia',
    add_email: 'Aggiungi e-mail',
    saved_successfully: 'Salvataggio avvenuto correttamente',
    saved_failed: 'Salvataggio non riuscito',
    deleted_successfully: 'Eliminazione avvenuta correttamente',
    deleted_failed: 'Eliminazione non riuscita',
    email: 'E-mail',
    please_enter_email_address: 'Inserisci un indirizzo e-mail',
    please_enter_the_correct_email_address: `Inserisci l'indirizzo e-mail corretto`,
    time_in_a_pad_goal: 'OBIETTIVO TEMPO NEL PANNOLONE',
    time_goal: 'OBIETTIVO TEMPO',
    body_temperature: 'Temperatura corporea',
    upper_goal_limit: `limite superiore dell'obiettivo`,
    lower_goal_limit: `limite inferiore dell'obiettivo`,
    time_of_fall: 'ora della caduta',
    heart_rate: 'Frequenza cardiaca',
    max_heart_rate: 'Frequenza cardiaca massima',
    min_heart_rate: 'Frequenza cardiaca minima',
    average_heart_rate: 'Frequenza cardiaca media',
    oximetry: 'Ossimetria',
    blood_o2_saturation: 'saturazione di ossigeno nel sangue',
    min_oximetry: 'Ossimetria minima',
    max_oximetry: 'Ossimetria massima',
    average_oximetry: 'Ossimetria media',
    respiration: 'Respirazione',
    breathing_pattern: 'schema respiratorio',
    breath: 'respiro',
    respiration_vs_oximetry: 'Respirazione vs Ossimetria',
    min_respiration: 'Respirazione minima',
    max_respiration: 'Respirazione massima',
    average_respiration: 'Respirazione media',
    balance: 'Equilibrio',
    falls_and_balance: 'cadute ed equilibrio',
    loss_of_balance_events: 'Eventi di perdita di equilibrio',
    sudden_changes_in_body_orientation: `Cambiamenti improvvisi nell'orientamento del corpo`,
    goal_limit: 'limite obiettivo',
    last_event_exceeding_goal: `L'ultimo evento supera l'obiettivo`,
    balance_loss_events: 'Eventi di perdita di equilibrio',
    per_7_days: 'per 7 giorni',
    body_lean_over_7_days: 'Inclinazione corpo in 7 giorni',
    chart_shows_tendency:
      'Il grafico mostra la tendenza del corpo a inclinarsi verso una particolare direzione mentre si muove',
    lean_forward: 'Inclinazione in avanti',
    backwards: 'indietro',
    forward: 'in avanti',
    vitals: 'PARAMETRI VITALI',
    vitals_signs: 'PARAMETRI VITALI',
    spo2: 'SPO2',
    pulse: 'Polso',
    abdominal_movement: 'Movimento addominale',
    min: 'min',
    attach_the_pod:
      'Agganciare il modulo solo quando il {patient} indossa già il {pad}. Muovere e manipolare i pannoloni prima che siano stati indossati dal {patient} potrebbe causare il rilevamento errato di una caduta.',
    body_positions_analysis: 'Analisi delle posizioni del corpo',
    repositioning: 'Riposizionamento',
    stayed_in_one_position: 'posizione invariata',
    change_in_position: 'cambiamento di posizione',
    no_pod_data: 'nessun dato dal modulo',
    possible_intervention: 'Possibile intervento',
    body_position_goal: 'OBIETTIVO POSIZIONE DEL CORPO',
    tap_to_setup_body_position_goals:
      'tocca per impostare gli obiettivi di posizione del corpo',
    time_blocks_greater_than: 'periodi di tempo maggiori di',
    will_be_highlighted: 'saranno evidenziati',
    chart_filters: 'FILTRI GRAFICO',
    tap_to_show: 'tocca per mostrare',
    tap_to_hide: 'tocca per nascondere',
    notifications: 'Notifiche',
    time_to_reposition: 'Ora-di-riposizionamento',
    hour: 'ora',
    hours: 'ore',
    minute: 'minuto',
    minutes: 'minuti',
    sensor_disconnected: 'sensore scollegato',
    from: 'DA',
    to: 'A',
    quick_start_guide: 'Guida rapida',
    wet_outside: 'Umidità fuori pannolone',
    attend_fall: 'ASSISTI CADUTA',
    reclip_pod: 'FISSA NUOVAMENTE IL MODULO',
    change_position: 'MODIFICA POSIZIONE',
    replace_battery: 'SOSTITUISCI LA BATTERIA',
    allowed_time_exceeded: 'Tempo consentito superato',
    wetness_outside: 'Umidità fuori',
    analysing_pad: 'Analisi {pad}',
    pad_not_selected: '{pad} non selezionato',
    silence: 'Silenzia',
    silence_confirm_box_title: 'Silenzia caduta',
    silence_confirm_box_content:
      'Silenziare la notifica di caduta la rimuoverà dalla dashboard del gruppo. Vuoi procedere? ',
    yes: 'SÌ',
    no: 'NO',
    pad_status: 'STATO PANNOLONE',
    check_pad_fill: 'VERIFICA RIEMPIMENTO DEL PANNOLONE',
    patient_profile: 'PROFILO DEL {patient}',
    periods: 'Periodi',
    products: 'Prodotti',
    active: 'attivo',
    manage_user_profile: 'Gestisci profilo utente',
    sign_out: 'Esci',
    view: 'Visualizza',
    groups: 'gruppi',
    groups_in_view: 'Gruppi in vista',
    total_daily_profile: 'Profilo totale giornaliero',
    day_profile: 'Profilo diurno',
    night_profile: 'Profilo notturno',
    pad_fill_profile_goal: 'OBIETTIVO DEL PROFILO DI RIEMPIMENTO DEL {pad}',
    tap_to_setup_pad_fill_profile_goals:
      'tocca per impostare gli obiettivi del profilo di riempimento del {pad}',
    insufficient_data: 'Dati insufficienti',
    last_7_days: 'Ultimi 7 giorni',
    pad_removed: 'pannolone rimosso',
    view_groups: 'Visualizza gruppo/i',
    minimum_voiding_into_pad: 'Svuotamento minimo nel {pad}',
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
    Sunday: 'Domenica',
    disconnected_desc:
      'in attesa che il modulo venga riagganciato sul {pad}...',
    pod_unclipped_desc: `in attesa che il pannolone torni nel raggio d'azione...`,
    password_policy: 'Politica sulle password',
    position_chart: 'Grafico della posizione',
    hi_everyone: 'Salve a tutti',
    voiding_chart_email_content:
      'Il grafico dello svuotamento inviato via e-mail è pronto per essere esaminato.',
    pad_fill_profile_chart_email_content:
      'Il grafico del profilo di riempimento del {pad} inviato via e-mail è pronto per essere esaminato.',
    position_chart_email_content:
      'Il grafico della posizione inviato via e-mail è pronto per essere esaminato.',
    temperature_chart_email_content:
      'Il grafico della temperatura inviato via e-mail è pronto per essere esaminato.',
    heare_rate_chart_email_content:
      'Il grafico della frequenza cardiaca inviato via email è pronto per essere esaminato.',
    oximtry_chart_email_content: `Il grafico dell'ossimetria inviato via e-mail è pronto per essere esaminato.`,
    respiration_chart_email_content:
      'Il grafico della respirazione inviato via e-mail è pronto per essere esaminato.',
    balance_chart_email_content: `Il grafico dell'equilibrio inviato via e-mail è pronto per essere esaminato.`,
    smartz_chart_email_content:
      'Il grafico Smartz™ inviato via e-mail è pronto per essere esaminato.',
    best_regards: 'Cordiali saluti',
    the_simavita_team: 'Il team operativo Smartz',
    days: 'giorni',
    weeks: 'settimane',
    years: 'anni',
    reset_all_users_passwords: 'Reimposta password di tutti gli utenti',
    reset_all_passwords: 'Reimposta tutte le password',
    reset: 'Reimposta',
    change_password: 'Cambia password',
    old_password: 'Vecchia password',
    lowercase: 'Minuscolo',
    uppdercase: 'Maiuscolo',
    number: 'Numero',
    please_select: 'Seleziona',
    loading_chart: 'Caricamento grafico',
    please_wait: 'Attendi...',
    edit_user: 'Modifica utente',
    add_user: 'Aggiungi Utente',
    edit_group: 'Modifica gruppo',
    add_group: 'Aggiungi gruppo',
    group_name: 'Nome gruppo',
    group_name_required: 'Il nome del gruppo è obbligatorio',
    patients: '{patients}',
    manage_user_account: `gestisci l'account utente`,
    filter_by_group_name: 'filtra per nome gruppo',
    delete_group_warning: `Tieni presente che l'eliminazione del gruppo è permanente.`,
    delete_patient_warning: `L'eliminazione dei dati personali e del {patient} è permanente.`,
    pod_mac: 'Mac del modulo',
    pod_serial_number: 'Numero di serie del modulo',
    add_patient: 'Aggiungi {patient}',
    edit_patient: 'Modifica {patient}',
    alias: 'Nome alternativo',
    alias_required: 'Il nome alternativo è obbligatorio',
    pod_mac_required: 'Il mac del modulo è obbligatorio',
    pod_serial_number_required: 'Il numero di serie del modulo è obbligatorio',
    please_enter_capital_letters_and_numbers:
      'Inserisci lettere maiuscole e numeri',
    select_date_range: 'Seleziona un intervallo',
    start_time: 'ora inizio',
    end_time: 'ora fine',
    select_groups_to_collate: 'Seleziona i gruppi da raccogliere',
    all_groups: 'Tutti i gruppi',
    export_report: 'Esporta Rapporto',
    export_csv: 'Esporta CSV',
    reports: 'Rapporti',
    please_complete_form: 'Compila il modulo',
    nodes: 'Nodi',
    network_map: 'Schema della rete',
    network_utilisation: 'Utilizzo della rete',
    notify_me_when_nodes_offline: 'Avvisami quando uno o più nodi sono offline',
    zoom_in_chart: 'Abilita zoom nel grafico',
    latency: 'Latenza',
    lan: 'LAN',
    wifi_infrastructure: 'Infrastruttura Wi-Fi',
    standard_iot_network_map: 'Mappa di rete IoT standard',
    pods: 'Moduli',
    data: 'Dati',
    packet_less: 'Meno pacchetti',
    secondary_connection: 'Collegamento secondario',
    rssi: 'RSSI',
    no_nodes: 'Nessun nodo',
    share_code: 'Condividi il codice',
    //Start translation from here.
    active_patients: '{patients} attivi',
    archived_patients: '{patients} archiviati',
    archive: 'archivio',
    restore: 'ripristina',
    are_you_sure: 'Sei sicuro?',
    you_about_to_archive: `Stai per archiviare`,
    default_group_not_delete: 'Il gruppo predefinito non può essere eliminato',
    patients_belong_to: 'Pazienti appartenenti a',
    move: 'Sposta',
    warning: 'Attenzione',
    add_node: 'Aggiungi nodo',
    edit_node: 'Modifica nodo',
    room_name: 'Nome della stanza',
    mac_address: 'Indirizzo MAC',
    delete_node_warning: `L'eliminazione del nodo è permanente. `,
    mac_address_required: `L'indirizzo MAC è obbligatorio`,
    room_name_required: 'Il nome della stanza è obbligatorio',
    mac_address_format_warning: `Il formato dell'indirizzo MAC immesso non è corretto. Inseriscilo sotto forma di XX: XX:XX:XX:XX:XX`,
    connection_type: 'Tipo di connessione',
    device_role: 'Ruolo del dispositivo',
    device_type: 'Tipo di dispositivo',
    offline: 'Offline',
    node_management: 'Gestione dei nodi',
    time_period: 'Periodo di tempo',
    manufacturer: 'Produttore',
    product: 'Prodotto',
    please_select_time_period: 'Seleziona un periodo di tempo',
    please_select_manufacturer: 'Seleziona il produttore',
    please_select_product: 'Seleziona il prodotto',
    no_data: 'Nessun dato',
    please_select_manufacturer_first: 'Seleziona prima il produttore',
    details: 'Dettagli',
    time_period_warning:
      'Il periodo diurno e il periodo notturno devono coprire il tempo totale della giornata per 24 ore.',
    reset_successfully: 'Reset eseguito correttamente',
    region: 'Regione',
    select_at_least_one_group: 'Seleziona almeno un gruppo',
    node: 'Nodo',
    pods_location: 'Posizione dei moduli',
    pod_id: 'ID Modulo',
    accelerometer: 'Accelerometro',
    senser: 'Sensore',
    gain: 'Guadagno',
    offset: 'Compensazione',
    failed_to_connecte_smartz_service:
      'Impossibile connettersi al servizio Smartz<sup>®</sup>',
    add_to_smartz_group_failed:
      'Impossibile aggiungere al servizio del gruppo smartz',
    retry: 'Riprova',
    customization: 'Personalizzazione',
    customization_settings: 'Impostazioni personalizzate',
    colors: 'Colori',
    font: 'Carattere',
    logo: 'Logo',
    login_background: 'Sfondo login',
    apply: 'Applica',
    theme: 'tema',
    to_current_site: 'al sito corrente',
    customize_theme_text: `Personalizza l'aspetto del sito. In vena di avventura?`,
    create_a_custom_theme: 'Crea un tema personalizzato',
    custom_theme: 'Tema Personalizzato',
    preview: 'anteprima',
    reset_customization_settings:
      'Tutte le configurazioni sono state ripristinate ai valori predefiniti',
    drag_the_logo_here: 'Trascina il logo qui',
    or: 'o',
    click_upload: 'clicca su carica',
    only_image_files_can_be_uploaded: 'È possibile caricare solo file JPG/PNG',
    the_size_of_the_uploaded_image_cannot_exceed: `La dimensione dell'immagine caricata non può superare i 2 MB`,
    please_sign_out_to_preveiw_effect: `Dopo il caricamento, esci per visualizzare l'effetto in anteprima`,
    please_enter_theme_name: 'Inserisci il nome del tema',
    failed: 'Non riuscito',
    add_pod: 'Aggiungi modulo',
    edit_pod: 'Modifica modulo',
    filter_pod: 'Filtra per indirizzo mac del modulo',
    filter_node: 'Filtra per nodo, indirizzo MAC e stanza',
    delete_pod_warning: `L'eliminazione del modulo è permanente. `,
    delete_theme_warning: `L'eliminazione del tema sarà permanente.`,
    apply_theme_warning:
      'Nota: questa operazione applicherà le impostazioni personalizzate al nome di dominio. Attenzione.',
    please_enter_domain_name: 'Immetti il nome di dominio',
    domain_name_incorrect: 'Il formato del nome di dominio non è corretto',
    apply_successfully: 'Applicato con successo',
    location: 'Luogo',
    manufacturer_code: 'Codice Produttore',
    node_mac_address: 'Indirizzo Mac del nodo',
    expired: 'Scaduto',
    please_select_location: 'Seleziona il luogo',
    filter_patients: 'Filtra i {patients}',
    monitor_patient: 'Monitora il {patient}',
    patient: '{patient}',
    room: 'Stanza',
    assign: 'Assegna',
    unassign: `Annulla l'assegnazione`,
    unassign_patient_permanent: `Tieni presente che l'annullamento dell'assegnazione del Paziente è permanente.`,
    you_able_to_unassign: `Stai per annullare l'assegnazione`,
    node_mac_address_required: `L'indirizzo MAC del nodo è obbligatorio`,
    not_assigned: 'Non assegnato',
    assign_node_to: 'Assegna nodo a',
    create_user: 'Crea utente',
    email_is_required: `L'e-mail è obbligatoria`,
    created_successfully: 'Creato correttamente',
    manage_patient_data: 'GESTISCI I DATI DEL {patient}',
    selected_patient: '{patient} SELEZIONATO',
    archive_patient: 'ARCHIVIA {patient}',
    archive_patient_warning:
      'Archivia i dati del {patient}. Il {patient} non apparirà più sul sistema fino a quando non saranno ripristinati.',
    archive_patient_data: 'Archivia i dati del {patient}',
    restore_patient: 'Ripristina {patient}',
    restore_patient_warning:
      'Ripristina i dati archiviati in modo che possano essere visualizzati su questo sistema.',
    archive_date: 'Data archiviazione',
    restore_patient_data: 'Ripristina i dati del {patient}',
    delete_account: `ELIMINA L'ACCOUNT`,
    user_accounts: 'Account utente',
    selected_site: 'Sito selezionato',
    no_site: 'Nessun sito',
    drag_the_login_background_here: 'Trascina qui lo sfondo del login',
    drag_the_menu_background_here: 'Trascina qui lo sfondo del menu',
    patient_data_privacy: 'PRIVACY DEI DATI DEL Paziente',
    edit_theme: 'Modifica tema',
    drag_the_main_content_background_here:
      'Trascina qui lo sfondo del contenuto principale',
    opacity_desc: 'Opacità (trasparenza dei contenuti sospesi in background)',
    menu_bg: 'Sfondo del menu',
    main_content_bg: 'Colore dello sfondo principale',
    background: 'Sfondo',
    account: 'account',
    super_admin: 'super amministratore',
    help: 'Assistenza',
    filter_by_user_name: 'filtra per nome utente',
    drag_the_top_nav_background_here:
      'Trascina qui lo sfondo della barra di navigazione superiore',
    apply_theme: 'Applica tema',
    apply_to_this_domain: 'Applica a questo dominio',
    crop_image: 'Taglia immagine',
    enlarge: 'Ingrandisci',
    narrow: 'Riduci',
    left_rotation: 'Ruota a sinistra',
    right_rotation: 'Ruota a destra',
    remove_image: 'Rimuovi immagine',
    operation_area: 'Area di intervento',
    preview_area: 'Area di anteprima',
    logo_shape: 'Forma logo',
    show_as_circle: 'Visualizza come cerchio',
    history: 'Cronologia',
    status: 'Stato',
    download: 'Download',
    export: 'Esporta',
    created_date: 'Creazione data',
    next: 'Successivo',
    register: 'Registra',
    back: 'Indietro',
    create_an_organisation: `Crea un'organizzazione`,
    please_enter_organisation_name: `Inserisci il nome dell'organizzazione`,
    address: 'Indirizzo',
    please_enter_organisation_address: `Immetti indirizzo dell'organizzazione`,
    phone: 'Telefono',
    please_enter_organisation_phone: `Inserisci il telefono dell'organizzazione`,
    description: 'Descrizione',
    add_facility: 'Aggiungi struttura',
    edit_facility: 'Modifica struttura',
    facility: 'Struttura',
    no_room: 'Nessuna stanza',
    facility_name: 'Nome struttura',
    add_room: 'Aggiungi stanza',
    room_already_exists: 'La stanza esiste già',
    home: 'home',
    signed_into: 'Firmato in',
    please_select_an_organisation: `Seleziona un'organizzazione`,
    hello: 'Salve',
    useful_features: 'Funzioni utili',
    attention: 'Attenzione',
    quick_actions: 'Azioni rapide',
    no_patient_warning:
      'Non ci sono {patients} da monitorare. Aggiungi subito i {patients} per iniziare.',
    add_patient_quick_action_desc: 'Aggiungi un {patient} da monitorare',
    welcome_to_the_group_dashboard: 'Benvenuto nella dashboard del gruppo',
    show_me_more: 'Mostra di più',
    add: 'inserisci',
    welcome_to_patient_management: 'Benvenuto in Gestione del {patient}',
    update_patient: 'Aggiorna {patient}',
    update_patient_quick_action_desc: `Aggiorna i dettagli del {patient}`,
    change_patient_products: `Cambia i prodotti del {patient}`,
    change_patient_products_quick_action_desc:
      'Cambia il prodotto utilizzato dal {patient}',
    reassign_pod_to_patient: 'Riassegna il modulo al {patient}',
    reassign_pod_quick_action_desc: `Cambia il modulo del {patient}`,
    monitor_patient_with_a_node: 'Assegna nodo al {patient}',
    monitor_patient_with_a_node_quick_action_desc:
      'Esamina il nodo di un {patient}',
    welcome_to_the_administration_section:
      'Benvenuto nella sezione Amministrazione',
    invite_user: 'Invita utente',
    invite_user_quick_action_desc: 'Invita un utente al sistema',
    remove_or_archive_patient: 'Rimuovi/Archivia {patient}',
    remove_or_archive_patient_quick_action_desc:
      'Rimuovere un {patient} dalla dashboard',
    profile: 'Profilo',
    not_monitored: 'non monitorato',
    rounds: 'Giri',
    //translate permissions list
    'Super Admin': 'Super Amministratore',
    Algorithms: 'Algoritmi',
    Customisation: 'Personalizzazione',
    Account: 'Account',
    'Roles & Permissions': 'Ruoli e autorizzazioni',
    'Network Map': 'Schema della rete',
    'Network Utilisation': 'Utilizzo della rete',
    'Buildings & Rooms': 'Strutture e stanze',
    Manufacturers: 'Produttori',
    Settings: 'Impostazioni',
    Profile: 'Profilo',
    Devices: 'Dispositivi',
    Nodes: 'Nodi',
    'Pods Location': 'Posizione dei moduli',
    'Share Code': 'Condividi il codice',
    Users: 'Utenti',
    'User Accounts': 'Account utente',
    'Invite User': 'Invita utente',
    Patients: 'Pazienti',
    'Monitor Patient': 'Monitora il Paziente',
    'Patient Data Privacy': 'Privacy dei dati del Paziente',
    Archive: 'Archivio',
    Restore: 'Ripristina',
    'Patients Module': 'Modulo Pazienti',
    Export: 'Esporta',
    History: 'Cronologia',
    Report: 'Rapporto',
    Monitor: 'Monitora',
    //translate permissions list
    time_zone: 'Fuso orario',
    please_select_time_zone: 'Seleziona il fuso orario',
    add_facility_and_room: 'AGGIUNGI STRUTTURA E CAMERA',
    filter_by_facility_name: 'filtra per nome struttura',
    floor: 'Piano',
    please_enter_facility_name: 'Inserisci il nome della struttura',
    please_enter_floor_name: 'Inserisci il nome del piano',
    please_enter_room_number: 'Inserisci il numero della stanza',
    facility_name_already_exists: 'Il nome della struttura esiste già',
    floor_name_should_be_unique: 'Il nome del piano deve essere unico',
    room_number_should_be_unique: 'Il numero della stanza deve essere univoco',
    add_manufacturer: 'Aggiungi produttore',
    filter_by_manufacturer_code_or_name:
      'filtra per codice o nome del produttore',
    enabled: 'Abilitato',
    delete_manufacturer_warning: `L'eliminazione del produttore è permanente. `,
    please_enter_role_name: 'Inserisci il nome del ruolo',
    please_choose_one_as_the_current_organization:
      'Selezionane uno come organizzazione attuale',
    display_name: 'Visualizza nome',
    assign_roles: 'Assegna ruoli',
    remove: 'Rimuovi',
    please_assign_a_role_to_the_user: `Assegna un ruolo all'utente`,
    send_invitation: 'invia invito',
    invitation_email_sent: 'E-mail di invito inviata.',
    facility_and_Floor_and_Room: 'Struttura, piano e stanza',
    export_patient: 'esporta {patient}',
    export_patient_history_data: 'Esporta dati anamnesi {patient}',
    export_patient_data: 'Esporta dati {patient}',
    export_report_success_text: `Esportazione dei dati del {patient} in corso. Riceverai una notifica via e-mail quando sarà disponibile. Controlla lo stato di avanzamento nella scheda dei file. `,
    select_patients: 'Seleziona {patients}',
    export_in_progress: 'Esportazione in corso',
    continue: 'continua',
    please_enter_patient_name: `Inserisci il nome del {patient}`,
    please_enter_patient_alias: `Inserisci il nome alternativo del {patient}`,
    facility_and_room: 'Struttura e stanza',
    create_new: 'Crea Nuovo',
    add_facility_and_floor_and_room: 'Aggiungi struttura, piano e stanza',
    select_facility_floor_room: 'Selziona struttura, piano e stanza',
    choose_one: 'Selezionane uno',
    enter_manually: 'Inserisci manualmente',
    pod_serial_number_format_incorrect:
      'Il formato del numero di serie del modulo inserito non è corretto.',
    add_a_manufacturer_to_continue: 'Aggiungi un produttore per continuare',
    please_enter_subscription_code: 'Inserisci il codice di iscrizione',
    added_successfully: 'Aggiunto con successo',
    select_a_patient: 'Seleziona un {patient}',
    assign_products: 'Assegna prodotti',
    assign_pod: 'Assegna modulo',
    assign_node: 'Assegna nodo',
    we_have_created_a_default_facility:
      'abbiamo creato una struttura, un piano e una stanza predefiniti per la tua organizzazione',
    if_you_want_edit_this_facility: `Se desideri modificare le informazioni di questa struttura, tocca`,
    or_you_can: 'oppure puoi',
    already_registered: 'Già registrato',
    sign_up: 'Iscriviti',
    create_account: 'Crea Account',
    pod_and_diaper: 'Modulo e {pad}',
    pod_and_diaper_content: ` <p class="underline">Per collegare il modulo al {pad}, procedi nel seguente modo:</p>
          <ul>
            <li>
            Allinea le tre strisce del {pad} intelligente con i tre perni dorati del modulo Smart.
            </li>
            <li>Gancio del modulo sulla <span class="underline">parte anteriore</span> del {pad} intelligente</li>
            <li>
            La luce verde lampeggia rapidamente per 3 secondi, quindi diventa fissa per 1 secondo = buona connessione
            </li>
            <li>
            Nessuna luce verde lampeggiante dopo 20 secondi = nessuna connessione. Sgancia e aggancia nuovamente il modulo Smart
            </li>
            <li>Se la luce non lampeggia con un collegamento corretto, la batteria è scarica.</li>
          </ul>`,
    home_landing_slide1_title: 'Benvenuto nel portale Salute',
    home_landing_slide1_content: `
      <p>Il portale Salute consente di monitorare la continenza e il benessere del {patient}.</p>
      <p>Monitora i gruppi di {patients} per dare priorità alle azioni e fornire un'assistenza centrata sull'individuo.</p>`,
    home_landing_slide2_title: 'Tecnologia {pad} intelligente',
    home_landing_slide2_content: `
      <p>Quando un modulo Smart è collegato a un {pad} intelligente, trasmette i dati attraverso una rete che consente all'assistente di monitorare il {patient} attraverso il portale Salute.</p>
      <p>Una volta che il {patient} è stato inserito nel sistema, saprai subito quando cambiare il {pad} e potrai visualizzare i dati storici. Puoi anche impostare facilmente degli obiettivi ed essere avvisato quando cambiare il {pad}, la posizione del {patient}, monitorare la produzione di liquidi, controllare la temperatura circostante e le possibili cadute.</p>`,
    home_landing_slide4_title: 'Aggiungi primo {patient}',
    home_landing_slide4_content: `
      <p>Per iniziare, aggiungi un {patient} utilizzando il pulsante Azione rapida e segui le istruzioni.</p>
      <p>Il sistema ti assisterà durante tutto il processo di configurazione del {patient}.</p>`,
    home_landing_slide5_title: 'Azioni rapide',
    home_landing_slide5_content: `
      <p>Permettono di accedere ad azioni frequenti come l'aggiunta di un {patient}.</p>
      <p>Una procedura guidata ti guiderà attraverso tutti i passaggi necessari. </p>`,
    dashboard_landing_slide1_title: 'Benvenuto nella dashboard del gruppo',
    dashboard_landing_slide1_content: `
      <p>Monitora tutti i {patients} sulla dashboard, così saprai quando i {patients} hanno bisogno di attenzione.</p>
      <p>Il carico di lavoro può essere ridotto seguendo le istruzioni visive del sistema.</p>`,
    dashboard_landing_slide2_title: 'Benvenuto nella dashboard del gruppo',
    dashboard_landing_slide2_content: `<ul>
      <li>Le icone indicano lo stato del {patient}</li>
      <li>Nella Dashboard sono presenti due sezioni: la sezione <span class="underline">Azione richiesta</span> e la sezione <span class="underline">Monitoraggio</span>.</li>
      <li>Per ridurre il carico di lavoro e migliorare l'assistenza al {patient}, utilizza le icone <span class="underline">"Azione richiesta"</span> con priorità elevata</li>
    </ul>`,
    dashboard_landing_slide3_title: 'Gli stati del {pad}',
    dashboard_landing_slide3_content: `
      <p>Lo stato del {pad} e l'"Ora del cambio" sono rappresentati da un sistema a semaforo:</p>
      <ul>
        <li><span class="red-text"><span class="underline">Rosso</span> = cambio pannolone,</span> cioè {pad} bagnato a rischio di perdite</li>
        <li><span class="yellow-text"><span class="underline">Giallo</span> = prepararsi a cambiare il {pad},</span> cioè il {pad} sta raggiungendo la capacità massima</li>
        <li><span class="green-text"><span class="underline">Verde</span> = nessuna azione</span> cioè {pad} asciutto</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Altri stati',
    dashboard_landing_slide4_content: `
      <p>Per garantire la continuità della cura, presta attenzione a tutte le azioni visualizzate sulla dashboard:</p>
      <ul>
        <li>Il simbolo "Connessione persa" indica che la connessione Bluetooth è stata persa e che potrebbe verificarsi una perdita di dati.</li>
        <li>Il simbolo "Cambia posizione" indica che è il momento di cambiare la posizione del {patient}.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Ottimizza',
    dashboard_landing_slide5_content: `<p>Rivedi le notifiche della dashboard di gruppo per ottimizzare la cura quotidiana del {patient}.</p>`,
    dashboard_landing_slide6_title: 'Filtri area',
    dashboard_landing_slide6_content: `
      <p>Il filtro area è una funzione opzionale che consente di visualizzare un'area selezionata sulla dashboard della struttura. Utilizza i filtri area con cautela, in quanto nascondono i {patients} esistenti e mostrano solo le selezioni del filtro.</p>
      <p>Per scegliere il nuovo filtro area: </p>
      <ol>
        <li>Seleziona l'area nel menu a tendina</li>
        <li>Tocca "Nuova area"</li>
        <li>Digita il "Nome filtro area"</li>
        <li>Seleziona l'edificio</li>
        <li>Seleziona i numeri di area, piano e stanza</li>
        <li>Rivedi la selezione del filtro nella casella di riepilogo del filtro</li>
        <li>Tocca per salvare questo filtro area</li>
        <li>Seleziona il filtro dell'area o "Gestisci aree" dal menu a tendina</li>
      </ol>
    `,
    home_landing_slide3_title: 'Modulo e {pad}',
    home_landing_slide3_content: `
    <ul>
      <li>Collega il modulo al {pad}</li>
      <li>Guarda le luci a LED verdi sul modulo</li>
      <li>Ricevi aggiornamenti sullo stato del {patient}</li>
    </ul>`,
    patient_landing_slide1_title: 'Dashboard individuale',
    patient_landing_slide1_content: `
      <p>Selezionando un singolo {patient}, una nuova dashboard visualizzerà lo stato di tutte le funzionalità attualmente monitorate, inclusi modulo e {pad} intelligente in uso.</p>
      <p>Scegli un altro {patient} da visualizzare dal menu a tendina.</p>`,
    patient_landing_slide2_title: `Benvenuto nella sezione {patient}`,
    patient_landing_slide2_content: `
      <p>La dashboard individuale indica lo stato corrente del {patient}.</p>
      <p>La sezione Grafici acquisisce le tendenze relative allo stato di salute.</p>
      <p>È possibile impostare obiettivi specifici nella sezione Obiettivi e ricevere notifiche.</p>`,
    patient_landing_slide3_title:
      'Accedi a dashboard, grafici e obiettivi individuali',
    patient_landing_slide3_content: `<p>Sul lato sinistro della dashboard è possibile accedere alla sezione {patient}, Grafici e Obiettivi.</p>`,
    patient_landing_slide4_title: 'Dashboard {patient}/Individuale',
    patient_landing_slide4_content: `
      <ul>
        <li>Ogni {patient} ha la propria dashboard individuale</li>
        <li>Approfondisci lo stato individuale del tuo {patient}</li>
        <li>Passa da un {patients} all'altro selezionando dalla freccia del menu a tendina</li>
      </ul>`,
    patient_landing_slide5_title: 'Grafici',
    patient_landing_slide5_content: `
      <p>Esistono vari grafici che consentono di visualizzare e interpretare i dati, tra cui:</p>
      <ul>
        <li>Grafico di svuotamento</li>
        <li>Profilo riempimento {pad}</li>
        <li>Grafico della posizione.</li>
      </ul>
      <p>Puoi stamparli e condividerli per rivedere e adeguare la cura del {patient}.</p>`,
    patient_landing_slide6_title: 'Obiettivi',
    patient_landing_slide6_content: `
      <p>Per migliorare ulteriormente la cura del {patient}, è possibile impostare obiettivi specifici. Questi includono:</p>
      <ul>
        <li>Riposizionamento del corpo</li>
        <li>Cura della pelle</li>
        <li>Profilo riempimento {pad}</li>
        <li>Temperatura</li>
        <li>Cadute.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>Selezionando l'intervallo è possibile visualizzare un massimo di 7 giorni.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>Il grafico di svuotamento fornirà una visione olistica della cronologia di svuotamento dei {patients}.</li>
        <li>I dati in tempo reale vengono visualizzati sulla tabella di svuotamento quando si utilizza il sistema Smartz<sup>®</sup>.</li>
        <li>Questo grafico consente di passare dalla visualizzazione del ciclo del {pad} alla panoramica degli eventi di svuotamento.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Le icone possono essere filtrate per selezione.</li>
        <li>La legenda sotto il grafico di svuotamento visualizza le icone visualizzate nel grafico.</li>
        <li>Tocca "filtri grafico" per selezionare o deselezionare le icone che desideri visualizzare.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>La visualizzazione di questo grafico consente di:</p>
      <ul>
        <li>identificare i momenti in cui il {patient} potrebbe essere portato in bagno con successo;</li>
        <li>se il {pad} è stato cambiato entro un periodo di tempo accettabile;</li>
        <li>il numero di cambi di {pad} nel periodo;</li>
        <li>condividere e stampare il grafico.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>Il grafico degli eventi mostra tutti gli eventi per lo stato di {pad}, modulo, obiettivo e rete.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>Il "Profilo totale giornaliero" mostra la quantità totale di liquido svuotato nel {pad} nell'arco delle 24 ore.</li>
        <li>L'uscita giornaliera nel {pad} è indicata sopra ogni goccia.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>L'icona a destra indica il volume "medio" prodotto nel periodo di giorni selezionato.</li>
        <li>Attiva/disattiva per visualizzare separatamente i profili "Diurno" e "Notturno".</li>
        <li>Il grafico indica se è stato impostato o attivato un obiettivo del profilo di riempimento del {pad}.</li>
        <li>Scegli di impostare l'obiettivo, se necessario.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>Il profilo totale giornaliero mostra la quantità totale di fluido che è stato svuotato nel {pad} nell'arco delle 24 ore.</li>
        <li>Se il {patient} ha una riduzione della produzione di urina, può essere un indicatore per aumentare l'idratazione.</li>
        <li>Condividi e stampa il tuo grafico.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>Il grafico visualizza il periodo di tempo in una posizione del corpo in un numero selezionato di giorni.</li>
        <li>Per visualizzare ulteriori dettagli, posiziona il puntatore del mouse sul grafico.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Tocca "filtri grafico" per selezionare o deselezionare le posizioni che desideri visualizzare.</li>
        <li>Il grafico evidenzia se è stato impostato un obiettivo di posizione del corpo.</li>
        <li>Tocca per impostare l'obiettivo.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>Se il {patient} è soggetto a rottura della pelle o a lesioni da pressione, impostando l'obiettivo ti verrà comunicato il momento in cui cambiare la posizione del {patient}.</li>
        <li>Quando si seleziona "stampa", le posizioni e i periodi di tempo sono elencati in modo più dettagliato. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Controlla la sezione della lampadina per maggiori dettagli.</li>
      </ul>`,
    body_position_goal_help_title: 'Obiettivo di riposizionamento del corpo',
    body_position_goal_slide1_content: `
      <ul>
        <li>Impostando l'obiettivo, l'assistente riceverà una notifica sull'ora in cui modificare la posizione del {patient}.</li>
        <li>Utilizza questo obiettivo se il {patient} è soggetto a rotture della pelle o a lesioni da pressione.</li>
        <li>La riduzione del tempo in una stessa posizione potrebbe contribuire ad alleviare le lesioni da pressione.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
        <li>Sposta il cursore per scegliere la durata massima di permanenza del {patient} in un'unica posizione durante il giorno e/o la notte.</li>
        <li>Tocca per salvare l'obiettivo.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>A questo punto hai selezionato la durata massima di permanenza del {patient} in una posizione e nella sezione "Azione necessaria" ti verrà segnalato quando modificarla.</li>
      </ul>`,
    skin_management_goal_help_title: 'Obiettivo di gestione della pelle',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Cambiare il {pad} più regolarmente potrebbe aiutare a mantenere la pelle del {patient} asciutta e a ridurre le irritazioni cutanee.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
        <li>Sposta il cursore per scegliere la durata massima durante la quale desideri che il {patient} trascorra con un {pad}.</li>
        <li>Tocca per salvare l'obiettivo.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>A questo punto, nella sezione "Azione richiesta" ti verrà notificato quando cambiare il {pad} del {patient}.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Temperatura modulo circostante',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>Questo obiettivo consente di impostare la temperatura minima/massima del modulo circostante.</li>
        <li>Imposta questo obiettivo se hai dubbi sulla fluttuazione della temperatura del {patient}.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
        <li>Per essere avvisato di qualsiasi variazione di temperatura modulo circostante, sposta il cursore per scegliere la temperatura minima e massima.</li>
        <li>Tocca per salvare l'obiettivo.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>Nella sezione "Azione necessaria" riceverai una notifica quando la temperatura modulo circostante non rientra nell'intervallo impostato.</li>
      </ul>`,
    pad_fill_profile_goal_help_title:
      'Obiettivo del profilo di riempimento del {pad}',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>Questo obiettivo consente di impostare il volume minimo/massimo di svuotamento nel {pad} se temi che il {patient} abbia una bassa produzione di urina.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
        <li>Sposta il cursore per selezionare il volume prescelto per il giorno e/o la notte.</li>
        <li>Tocca per salvare l'obiettivo.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>Ora riceverai una notifica nella sezione "Azione richiesta" quando il volume di uscita del {patient} nel {pad} è al di fuori dell'intervallo impostato.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Obiettivo di rilevamento caduta',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>Questo obiettivo ti informerà se il tuo {patient} è caduto.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Scegli quale {patient} visualizzare semplicemente utilizzando il menu a tendina.</li>
        <li>Sposta il cursore in posizione ON per attivare l'obiettivo.</li>
        <li>Per impostazione predefinita, l'opzione 'Tempo in posizione' è attivata. </li>
        <li>Tocca per salvare l'obiettivo.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>Se si è verificata una caduta, verrà visualizzata un'icona lampeggiante nella sezione "Azione richiesta".</li>
        <li>Silenziando la caduta nella "Dashboard individuale", l'icona verrà rimossa dalla dashboard principale.</li>
      </ul>`,
    voiding_chart_help_dialog_title: 'Utilizzo del grafico di svuotamento',
    pad_fill_profile_chart_help_dialog_title:
      'Utilizzo del profilo di riempimento del {pad}',
    position_chart_help_dialog_title:
      'Utilizzo del grafico della posizione del corpo',
    pad_fill_profile_goal_help_dialog_title: `Impostazione dell'obiettivo del profilo di riempimento del {pad}`,
    skin_care_goal_help_dialog_title: `Impostazione dell'obiettivo di gestione della cura della pelle`,
    position_goal_help_dialog_title: `Impostazione dell'obiettivo di riposizionamento del corpo`,
    temperature_goal_help_dialog_title: `Impostazione dell'obiettivo di temperatura modulo circostante`,
    fall_detection_goal_help_dialog_title: `Impostazione dell'obiettivo di rilevamento delle cadute`,
    invite_user_quick_action_desc_for_home_landing:
      'Invita un operatore sanitario a unirsi a questa organizzazione',
    archived_successfully: 'Archiviazione completata con successo',
    verification_passed: 'Verifica superata',
    verification_failed: 'Verifica non riuscita',
    verify_error_msg_801: `Il tuo invito è scaduto o non è più valido. Per richiedere un altro invito, contatta l'amministratore dell'organizzazione.`,
    verify_error_msg_802: `Il tuo invito non è valido per questo utente. Se hai effettuato l'accesso come utente diverso, prima di accettare questo invito. Esci e riprova.`,
    verify_error_msg_803: 'Utente non trovato.',
    verify_error_msg_804: 'Codice di invito non trovato.',
    verify_error_msg_805: `Sei già un membro dell'organizzazione a cui vuoi partecipare.`,
    verify_success_msg: 'Benvenuto nella nuova organizzazione.',
    verify_error_msg_not_sign_in: `Accedi per partecipare all'organizzazione. <br/> Se non hai un account, registrati prima.`,
    verify_error_msg_620: 'Il codice non è valido o è scaduto',
    verify_error_msg_622: `Impossibile partecipare all'organizzazione. Il codice di invito non è valido per questo indirizzo email.`,
    failed_to_get_chart_data: 'Impossibile inviare i dati del grafico.',
    filter: 'Filtra',
    please_select_facility_first: 'Seleziona prima la struttura',
    areas: 'Area/e',
    floors: 'Piano/i',
    new_area: 'Nuova Area',
    manage_areas: 'Gestisci aree',
    show_all_facilities: 'Mostra tutte le strutture',
    show_all_areas: 'Mostra tutte le aree',
    new_area_filter: 'Nuovo filtro area',
    area_filter_name: 'Nome filtro area',
    area: 'Area',
    please_enter_area_filter_name: `Inserisci il nome del filtro dell'area`,
    please_select_facility: 'Seleziona la struttura',
    please_select_floor_and_room: 'Seleziona piano e stanza',
    please_select_organisation: `Seleziona l'organizzazione`,
    filter_summary: 'Riepilogo filtro',
    show_patients_from: 'Mostra {patients} da',
    in: 'in',
    and: 'e',
    belonging_to: 'appartenenti a',
    select_an_area: `Seleziona un'area`,
    manage_area: 'Gestisci area',
    please_select_area_filter: 'Seleziona il filtro area',
    delete_area: 'Elimina area',
    keep_in_mind_delete_area: `L'eliminazione dell'area sarà permanente. `,
    facility_information: 'Informazioni sulla struttura',
    floor_information: 'Informazioni sul piano',
    room_information: 'Informazioni sulla stanza',
    number_of_floors: 'Numero di piani',
    please_enter_number_of_floors: 'Inserisci il numero di piani',
    number_of_rooms: 'Numero di stanze',
    please_enter_number_of_rooms: 'Inserisci il numero di stanze',
    add_floor: 'Aggiungi piano',
    remove_floor: 'Rimuovi piano',
    remove_room: 'Rimuovi stanza',
    select_area_warning: `Area e piano non possono essere selezionati contemporaneamente. <br/>Seleziona una sola opzione.`,
    manage_area_filter: 'Gestisci filtro area',
    no_area: 'Nessuna area',
    there_are_no_patient_to_manage: 'Non ci sono {patients} da gestire.',
    default_themes: 'Temi predefiniti',
    custom_themes: 'Temi personalizzati',
    background_color: 'Colore di sfondo',
    top_navigation_background_color:
      'Colore di fondo della barra di navigazione superiore',
    top_nav_text_color: 'Colore del testo della barra di navigazione superiore',
    top_nav_active_text_color:
      'Colore del testo attivo della barra di navigazione superiore',
    sidebar_background_color: 'Colore di sfondo della barra laterale',
    sidebar_active_block_background_color:
      'Colore di sfondo del blocco attivo della barra laterale',
    sidebar_text_color: 'Colore del testo della barra laterale',
    sidbar_active_block_text_color:
      'Colore del testo del blocco attivo della barra laterale',
    card_title_background_color: 'Colore di sfondo del titolo della scheda',
    card_title_text_color: 'Colore del testo del titolo della scheda',
    card_body_background_color: 'Colore di sfondo del corpo della scheda',
    card_button_color: 'Colore del pulsante della scheda',
    room_number: 'Numero stanze',
    verify_invitation: 'VERIFICA INVITO',
    well_done: 'Ben fatto!',
    you_have_updated_the_patient: `Hai aggiornato i dettagli del {patient}.`,
    you_have_created_the_patient:
      'Hai aggiunto un {patient} che può essere visualizzato sulla dashboard di gruppo.',
    tell_me_more: 'Dimmi di più',
    registered_pods: 'Moduli registrati',
    registered_nodes: 'Nodi registrati',
    select: 'Seleziona',
    start: 'Inizia',
    end: 'Fine',
    floor_name: 'Nome del piano',
    sign_in_failed: 'Accesso non riuscito',
    skin_care_goal_title: 'Tempo nel {pad}',
    time_in_wet_pad: 'Tempo nel {pad} bagnato',
    'Event Chart': 'Grafico eventi Smartz',
    account_information: 'Informazioni account',
    given_name: 'Nome impostato',
    surname: 'Cognome',
    please_enter_pod_serial_number: 'Inserisci il numero di serie del modulo',
    manufacturer_subscription_code: `Codice di abbonamento del produttore`,
    remove_node_mac_address: 'Rimuovi indirizzo MAC del nodo',
    link_a_node_mac_address: 'Collega un indirizzo Mac del nodo',
    export_data: 'Esporta dati',
    available_files: 'File disponibili',
    export_patient_data_desc:
      'Fai clic sul seguente pulsante per esportare i dati cronologici di',
    dry_diaper: '{pad} asciutto',
    wet_diaper: '{pad} bagnato',
    change_diaper: 'Cambia {pad}',
    external_humidity: 'Umidità esterna',
    smartz_events: ' Eventi Smartz<sup>®</sup>',
    smartz_events_chart_email_content:
      'Il grafico degli eventi inviato via e-mail è pronto per essere esaminato.',
    reposition: 'Riposiziona',
    fall: 'caduta',
    cycle: 'Ciclo',
    pad_cycle: 'ciclo {pad}',
    off_body: 'fuori dal corpo',
    pad_status_legend: 'Stato {pad}',
    analysing_diaper_legend: 'Analisi del {pad}',
    dry_wet_change_diaper: '{pad} asciutto/bagnato/cambio',
    pod_status: 'Stato del modulo',
    goal_status: `Stato dell'obiettivo`,
    diaper_removed_legend: '{pad} rimosso',
    time_to_change_legend: 'ora del cambio',
    out_of_range_legend: 'fuori intervallo',
    diaper_not_selected: '{pad} non selezionato',
    duration: 'Durata',
    small_void: 'Svuotamento leggero',
    medium_void: 'Svuotamento medio',
    large_void: 'Svuotamento grande',
    view_mode: 'Modalità visualizzazione',
    voids_only: 'solo svuotamenti',
    void_event_size: 'dimensione evento svuotamento',
    pad_start: 'Avvia {pad}',
    pad_end: 'Fine {pad}',
    exceed_goal_time: 'Supera il tempo obiettivo',
    reclip: 'riaggancia',
    unstable_readings: 'Letture instabili',
    not_selected: 'Non selezionato',
    analysing: 'Analisi',
    create_organisation: 'Crea organizzazione',
    all_times_are_in: 'Tutti gli orari sono in',
    failed_to_get_goal_settings:
      'Impossibile ottenere le impostazioni degli obiettivi',
    next_steps: 'Fasi successive',
    video: 'Video',
    monitor_warning:
      'Il monitoraggio non è disponibile perché non esiste un modulo Smartz<sup>®</sup> assegnato a',
    find_further_information: 'Trova ulteriori informazioni',
    here: 'qui',
    savePatientPodErrMsg: `Il numero di serie del modulo fornito non esiste in questa organizzazione.`,
    savePatientNodeErrMsg: `L'indirizzo MAC del nodo fornito non esiste in questa organizzazione.`,
    already_registered_desc:
      'Accedi utilizzando il tuo nome utente e la password con cui ti sei registrato inizialmente.',
    create_account_desc:
      'Fornisci un nome utente e una password per creare un account utente e per accedere al sito.',
    signing_in: 'Accesso in corso',
    signing_out: 'Disconnessione in corso...',
    welcome: 'Benvenuto',
    top: 'In alto',
    facility_or_building: 'Struttura/Edificio',
    keep_at_least_one_facility: 'Conserva almeno una struttura',
    keep_at_least_one_floor: 'Conserva almeno un piano',
    keep_at_least_one_room: 'Conserva almeno una stanza',
    rename: 'Rinomina',
    domain_name: 'Nome dominio',
    subscription_code: 'Codice abbonamento',
    events: 'Eventi',
    no_pods_text: 'Non ci sono moduli registrati in questa organizzazione.',
    no_nodes_text: 'Non ci sono nodi registrati in questa organizzazione.',
    confirm_deletion: 'Conferma eliminazione.',
    confirm_archive: 'Conferma archiviazione.',
    account_deletion: 'Eliminazione account',
    delete_account_warning: `L'eliminazione dell'account utente e dei dati personali è permanente.`,
    deletion: 'Eliminazione',
    restoring_patient: 'Ripristino del {patient}',
    font_family: 'Famiglia di caratteri',
    font_size: 'Dimensioni carattere',
    font_color: 'Colore carattere',
    main_title: 'Titolo principale',
    title: 'Titolo',
    small_title: 'Titoletto',
    body_text: 'Corpo del testo',
    body_text_small: 'Corpo del testo (piccolo)',
    supplementary_text: 'Testo supplementare',
    primary_text: 'Testo principale',
    regular_text: 'Testo normale',
    secondary_text: 'Testo secondario',
    placeholder_text: 'Testo segnaposto',
    top_nav_background: 'Sfondo della barra di navigazione superiore',
    edit_facility_and_floor_and_room: 'Modifica struttura, piano e stanza',
    please_select_buildings: 'Seleziona gli edifici',
    please_select_floors: 'Seleziona i piani',
    please_select_rooms: 'Seleziona le stanze',
    facility_setup: 'Configurazione della struttura',
    view_a_patient_by_selecting_from_drop_down_menu:
      'Visualizza un {patient} selezionando dal menu a discesa.',
    monitoring: 'monitoraggio',
    silencing: 'Silenzio',
    fall_detection: 'rilevamento delle cadute',
    pod: 'Pod',
    diaper: '{pad}',
    time_in_diaper: 'Tempo nel {pad}',
    setup_area_filter_desc:
      'Seguire questi passaggi per configurare un nuovo filtro di area.',
    max_time_in_pad: 'Tempo massimo nel {pad}',
    max_time_in_pos: 'Tempo massimo in posizione',
    change_in: 'variazione in',
    not_monitoring: 'Non monitoraggio',
    exceed_allowed_time: 'Superare il tempo consentito',
    exceed_predicted_time: 'Superare il tempo previsto',
    Pseudonymized: 'Pseudonimizzato',
    Anonymized: 'Anonimizzato',
    pseudonymized_permission_warning:
      "L'autorizzazione {patient} pseudonimizzata e l'autorizzazione {patient} di modifica non possono essere selezionate contemporaneamente. Seleziona una sola opzione.",
    anonymized_permission_warning:
      "L'autorizzazione {patient} anonimizzata e l'autorizzazione {patient} di modifica non possono essere selezionate contemporaneamente. Seleziona una sola opzione.",
    please_select_one_product:
      'Seleziona uno dei prodotti per il giorno o per la notte',
    none: 'Nessuno',
    invitation: 'Invito',
    has_invited: 'ha invitato',
    to_join: 'partecipare',
    invitation_desc:
      'Se hai già un account con questo indirizzo e-mail, accedi per partecipare',
    if_not_please: 'In caso contrario',
    accept: 'accetta',
    decline: 'rifiuta',
    acceptable_temperature_range: 'intervallo di temperatura ammissibile',
    temperature_alert_off: "L'avviso di temperatura è spento",
    temperature_alert_on:
      "L'avviso di temperatura è impostato in modo da attivarsi se la temperatura è",
    below: 'sotto',
    above: 'sopra',
    partial_body_repositioning: 'Riposizionamento parziale del corpo',
    minimum_angle_change: "variazione minima dell'angolo",
    degrees: 'gradi',
    goal_time_exceed: 'Tempo obiettivo superato',
    allowed_time_exceed: 'Tempo consentito superato',
    predict_time_exceed: 'Tempo previsto superato',
    safe_time_exceed: 'Tempo sicuro superato',
    brief_not_used: '{pad} non utilizzato',
    monitor_unstable_readings: 'Monitora letture instabili',
    leakage: 'Perdita',
    new_battery: 'Batteria nuova',
    exceed_safe_time_in_pad: 'Supera il tempo di sicurezza in {pad}',
    predicted_change_time: 'Tempo di modifica previsto',
    total_time: 'tempo totale',
    exceed_safe_time: 'Supera il tempo di sicurezza',
    consider_using_smartz_product: "considera l'utilizzo del prodotto smartz",
    non_smartz_product_in_use: 'Prodotto non smartz in uso',
    product_not_selected: 'prodotto non selezionato',
    assign_smartz_product_to_patient: 'assegna il prodotto smartz a {patient}',
    wait_a_moment: 'aspetta un momento...',
    find_patient: 'trova {patient}',
    life: 'Vita',
    flat_battery: 'batteria scarica',
    compliance_notifications: 'Notifiche di conformità',
    receive_email_notifications:
      "Ricevi notifiche via e-mail relative all'utilizzo del sistema e alla conformità",
    example: 'Esempio',
    receive_email_desc1:
      'quando le batterie scariche del Modulo non vengono sostituite in modo tempestivo, potrebbe risultare impossibile monitorare i {patients}',
    receive_email_desc2:
      'quando il personale di assistenza non raggiunge gli obiettivi di conformità',
    i_want_to_receive_these_notifications: 'Voglio ricevere queste notifiche',
    subscribe_successfully: 'Iscrizione riuscita',
    unsubscribe_successfully: 'Annullamento iscrizione riuscito',
    voltage: 'Tensione',
    generate: 'Genera',
    generate_report: 'Genera report',
    period: 'Periodo',
    baseline: 'Riferimento',
    trial: 'Prova',
    generate_in_progress: 'Generazione in corso',
    generate_desc:
      'Esportazione dei dati del report in corso. Riceverai una notifica via e-mail quando sarà disponibile. Controlla lo stato di avanzamento nel menu della cronologia.',
    report_history: 'Cronologia report',
    double_tap: 'Doppio tocco',
    time_period_inconsistent_warning:
      "L'arco temporale del periodo 1 e del periodo 2 deve essere coerente",
    trial_reports: 'Report di prova',
    'Trial Reports': 'Report di prova',
    Generate: 'Genera',
    resend_code: 'Invia nuovamente il codice',
    verification_required: 'Verifica richiesta',
    security_step_up: 'Aumento della sicurezza',
    security_step_up_desc:
      "Stiamo verificando i tuoi accessi in seguito all'aggiornamento del tuo livello di sicurezza",
    we_have_sent_mfa_code_first_line:
      'Ti abbiamo inviato un codice di sicurezza di 6 cifre al tuo indirizzo e-mail',
    we_have_sent_mfa_code_second_line:
      'Questo passaggio aggiuntivo dimostra che sei davvero tu',
    enter_secure_code: 'Inserisci il codice di sicurezza',
    trust_this_browser: 'Questo browser è affidabile',
    trust_browser_first_line:
      "Se il browser è affidabile su questo computer, non ti verrà richiesta l'autenticazione in due passaggi al prossimo accesso",
    trust_browser_second_line: `Non devi mai selezionare "Browser affidabile" quando utilizzi un computer pubblico o condiviso e ti consigliamo di scegliere solo i browser che utilizzi regolarmente`,
    not_now: 'Non ora',
    browser_can_not_be_trust: `I browser non possono essere considerati affidabili in modalità privata. Seleziona "Non ora" per proseguire con l'accesso`,
    Observation: 'Osservazione',
    observation: 'Osservazione',
    common_area: 'Area comune',
    qr_code: 'Codice QR',
    please_enter_patient_alias_to_search:
      'Inserisci lo pseudonimo del {patient} per effettuare la ricerca',
    smartz_observations: 'Osservazioni Smartz',
    scan_this_code_to_record_and_observation:
      "Scansiona questo codice per <br /> il record e l'osservazione",
    need_help: 'hai bisogno di aiuto?',
    scan_this_code_to_learn_about_smartz:
      'Scansiona questo codice per saperne di più su Smartz',
    summary: 'RIEPILOGO',
    incontinent_event_frquency: 'Frequenza degli eventi di incontinenza',
    bladder_daily: 'Vescica (giornaliero)',
    weekly: 'Settimanale',
    bowel_daily: 'Intestino (giornaliero)',
    diaper_utilisation: 'Utilizzo {pad}',
    day_pad: '{pad} diurno',
    usage: 'Utilizzo',
    units_during_day: 'unità durante il giorno',
    average_fill: 'Riempimento medio',
    night_pad: '{pad} notturno',
    unit_at_night: 'unità durante la notte',
    averaxe_fill: 'Riempimento medio',
    Period: 'Periodo',
    Observations: 'Osservazioni',
    No_Observations: 'Nessuna osservazione',
    data_quality: 'Qualità dei dati',
    pod_out_of_range: 'Modulo fuori intervallo',
    Assessment: 'Valutazione',
    Day: 'Giorno',
    inco_assessment: 'VALUTAZIONE INCO',
    bladder_chart: 'GRAFICO DELLA VESCICA',
    week: 'settimana',
    count: 'Conteggio',
    inco_assessment_email_content:
      'Il Grafico della Valutazione Inco inviato via e-mail è pronto per essere esaminato.',
    observation_chart: 'Grafico di osservazione',
    inco_observation_chart_content:
      'Il Grafico di Osservazione inviato via e-mail è pronto per essere esaminato.',
    product_name: 'Nome prodotto',
    total_void: 'Vuoto totale',
    utilisation: 'Utilizzo',
    node_network_error_msg:
      'La Dashboard non può essere aggiornata in questo momento a causa della perdita del collegamento con la rete di nodi Smartz presso la tua struttura. Contatta il tuo team di supporto informatico',
    'Inco Assessment': 'VALUTAZIONE INCO',
    'Observation Chart': 'Grafico di osservazione',
    reporting: 'Reportistica',
    reporting_page_desc:
      'Le seguenti informazioni sulla tua organizzazione verranno utilizzate per la Reportistica',
    baseline_trial_periods: 'PERIODI DI RIFERIMENTO/PROVA',
    rounds_shifts: 'Cicli/Turni',
    to_access_reports_go_to: 'Per accedere ai report vai a',
    portal: 'portale',
    you_are_about_to_remove_this_item: 'Stai per rimuovere questo elemento',
    add_round: 'Aggiungi ciclo/turno',
    edit_round: 'Modifica ciclo/turno',
    poster_qr_code: 'Codice QR del manifesto',
    smartz_id_card: "Scheda d'identità Smartz",
    card_qr_code: 'Codice QR della scheda',
    id_card: "Scheda d'identità",
    'Privacy Mode': 'Modalità privacy',
    bed_number: 'Numero di letto',
    please_input_bed_number: 'Inserisci il numero del letto',
    range: 'Intervallo',
    please_enter_name: 'Inserisci il nome',
    please_select_range: 'Seleziona un intervallo',
    core_breakup: 'Rottura centrale',
    body_repositioning: 'Riposizionamento del corpo',
    Dashboard: 'Dashboard',
    Organisations: 'Organizzazioni',
    RolesPermission: 'Autorizzazione ruoli',
    Network: 'Rete',
    Void: 'Vuoto',
    BodyPosition: 'Posizione del corpo',
    Event: 'Evento',
    FillProfile: 'Compila profilo',
    SkinCare: 'Cura della pelle',
    Chars: 'Grafici',
    Goals: 'Obiettivi',
    Node: 'Nodo',
    Pod: 'Modulo',
    Reports: 'Report',
    Invite: 'Invita',
    Private: 'Privato',
    'Inco-assessment': 'Valutazione Inco',
    application_link_key: 'Chiave collegamento richiesta',
    application_link_key_desc:
      'Questa è una chiave associata alla tua organizzazione.',
    remove_application_link_key_desc:
      'Rimuovi questa chiave se non vuoi associarla, oppure puoi',
    generate_a_new_one: 'generarne una nuova',
    generate_new_application_link_key_warning:
      'La chiave appena generata sovrascriverà la chiave di collegamento precedente',
    delete_application_link_key_warning:
      'Stai per eliminare questa chiave di collegamento della richiesta',
    copied_to_clipboard: 'Copiato negli appunti',
    failed_to_copy: 'Copia non riuscita',
    template: 'Modello',
    please_select_a_template: 'Seleziona un modello',
    Charts: 'Grafici',
    choose_permission_template_desc:
      'Scegli uno dei ruoli del modello qui di seguito per inserire automaticamente le autorizzazioni. Potrai quindi personalizzare le autorizzazioni in base alle tue specifiche esigenze',
    Interoperability: 'Interoperabilità',
    comment: 'Commento',
    please_enter_comment: 'Inserisci il commento',
    filter_by_organisation_name: "filtra per nome dell'organizzazione",
    physical_activity_chart: "Grafico dell'attività fisica",
    stationary: 'stazionario',
    sit_stand: 'seduto/in piedi',
    walk: 'camminata',
    jog: 'corsetta',
    run: 'corsa',
    physical_activity_chart_content:
      "Il grafico dell'attività fisica inviato via e-mail è pronto per essere esaminato.",
    PhysicalActivity: 'Attività fisica',
    bed_number_is_not_available: 'Questo numero di letto non è disponibile',
    show_archived_patients: 'Mostra {patients} archiviati',
    archived: 'Archiviato',
    create_facility: 'Crea struttura',
    create_new_organisation: 'Crea una nuova organizzazione',
    add_role_title: 'Aggiungi ruolo',
    create_new_role: 'Crea un nuovo ruolo',
    create_new_manufacturer: 'Crea un nuovo produttore',
    create_a_secondary_user: 'Aggiungi un utente secondario',
    please_enter_password: 'Inserisci la password',
    please_enter_password_again: 'Inserisci nuovamente la password',
    password_rule:
      'La password deve includere lettere maiuscole, minuscole, numeri e caratteri speciali.',
    password_length_rule: 'La password deve contenere da 8 a 12 caratteri.',
    reset_password_successfully: 'Password reimpostata con successo',
    invited_user_list: 'Elenco utenti invitati',
    basic_settings: 'Impostazioni di base',
    language: 'Lingua',
    date_time_format: 'Formato data e ora',
    measure_unit: 'Unità di misura',
    custom_system_terms: 'Termini di sistema personalizzati',
    custom: 'personalizza',
    singular: 'Singolare',
    plural: 'Plurale',
    term: 'Scadenza',
    pad_term_not_select_warning:
      'Seleziona la scadenza e del pannolone o inserisci una scadenza personalizzata',
    patient_term_not_select_warning:
      'Seleziona la durata del paziente o inserisci una durata personalizzata',
    register_an_installation_id: 'Registra un ID di insediamento',
    register_an_installation_id_desc:
      "Registra l'organizzazione in una rete con un elenco di nodi e moduli",
    installation_id: 'ID di insediamento',
    please_enter_installation_id: "Inserisci l'ID di insediamento",
    register_an_installation_id_successful:
      'Registrazione ID di insediamento riuscita',
    your_organization_is_already_linked_site:
      'La tua organizzazione è già collegata a',
    you_can: 'Puoi',
    add_a_different_installation_id: 'Aggiungere un ID di insediamento diverso',
    remove_this_installation_id: 'Rimuovere questo ID di insediamento',
    your_organization_is_not_link_organisation:
      'La tua organizzazione non è ancora collegata alla rete di nodi Smartz',
    add_installation_id_desc:
      "L'aggiunta di un ID di insediamento collegherà questa organizzazione a una rete di nodi Smartz, consentendo di accedere a tutti i nodi e i moduli disponibili in quella rete.",
    link_another_installation_id_warning:
      'Ricorda che questa operazione interromperà il collegamento alla precedente rete di nodi Smartz e ne creerà una nuova. Alcuni nodi e moduli che facevano parte di un ID di insediamento precedente potrebbero non essere disponibili.',
    remove_installation_id_warning:
      "Ricorda che questa operazione interromperà il collegamento alla precedente rete di nodi Smartz. I nodi e i moduli che facevano parte dell'ID di insediamento corrente potrebbero non essere disponibili.",
    remove_successful: 'Rimozione riuscita',
    add_lora_network: 'Aggiungi una rete LoRa',
    add_a_lora_network: 'Aggiungi una rete LoRa',
    add_a_different_lora_network: 'Aggiungi una rete LoRa diversa',
    remove_this_lora_network: 'Rimuovi questa rete LoRa',
    application_id: 'ID applicazione',
    please_enter_application_id: "Si prega di immettere l'ID dell'applicazione",
    add_lora_network_successful: 'Aggiunta rete LoRa riuscita',
    your_organization_is_already_linked_lora_network:
      'La tua organizzazione è già collegata a una rete LoRa',
    your_organization_is_not_link_lora_network:
      'La tua organizzazione non è ancora collegata a una rete LoRa, si prega',
    add_lora_network_desc:
      "L'aggiunta di una rete LoRa collegherà questa organizzazione a una rete LoRa. Ciò consentirà a questa organizzazione di accedere a tutti i dispositivi LoRa disponibili in quella rete.",
    link_another_lora_network_warning:
      'Si prega di notare che ciò interromperà il collegamento alla rete LoRa precedente e ne creerà una nuova. Alcuni dispositivi che facevano parte di una rete LoRa precedente potrebbero non essere disponibili.',
    remove_lora_network_warning:
      'Si prega di notare che ciò interromperà il collegamento alla rete LoRa. I dispositivi che facevano parte della rete LoRa attuale potrebbero non essere disponibili.',
    'Dashboard Type': 'Tipo di dashboard',
    Carer: 'Assistente',
    moodle_training: 'Apprendimento Moodle',
    care_plus_dashboard: 'Dashboard Care Plus',
    take_action: 'Esegui azione',
    task_completion_time: "Ora di completamento dell'attività",
    too_early: 'Troppo presto',
    too_late: 'Troppo tardi',
    ontime: 'In orario',
    great_work: 'Ottimo lavoro',
    pad_change_desc: '{patientAlias} è stato modificato {time} fa',
    battery_change_desc:
      'La batteria di {patientAlias} è stata sostituita {time} fa',
    position_change_desc:
      'La posizione di {patientAlias}è stata modificata {time} fa',
    fall_event_desc: 'La caduta di {patientAlias} è stata assistita {time} fa',
    days_unit: 'giorno/i',
    hours_unit: 'ora/e',
    minutes_unit: 'minuto/i',
    team_work: 'Lavoro di squadra',
    your_care_team_is_doing_great:
      'Il tuo team di assistenza sta svolgendo un ottimo lavoro',
    a_few_things_to_improve_on:
      'Alcune cose da migliorare per raggiungere il successo',
    improve_early_change_desc:
      'Cambia {pad} solo in seguito ad avvisi del sistema, feci, obiettivi fissati o perdite. Evita i cambiamenti di routine.',
    improve_change_response_time_desc:
      'Controlla regolarmente la dashboard, agisci prontamente per cambiare {pads} una volta che le icone diventano rosse.',
    improve_goal_response_time_desc:
      "Occupati di {patient} quando l'icona dell'obiettivo è visualizzata nella sezione Esegui Azione",
    improve_incorrect_clipping_desc:
      "Controlla il modulo e {pad} per eventuali difetti. Allinea il modulo alle strisce prima di agganciarlo e osserva la luce verde lampeggiante. Consulta l'App del preparatore per le istruzioni",
    improve_battery_change_desc:
      'Sostituisci tempestivamente la batteria quando viene indicato sul cruscotto o sul modulo',
    improve_leakage_desc:
      "Cambia immediatamente {pad} quando l'icona diventa rossa. Controlla la dimensione del {pad} o l'applicazione del {pad}",
    improve_frequent_lost_connection_desc:
      "Evita di perdere o smaltire il modulo. Aggancia il modulo al nuovo {pad} e assicurati che il {patient} sia all'interno dell'area di copertura.",
    low: 'Basso',
    medium: 'Medio',
    high: 'Alto',
    improve_offline_nodes_desc: `Diversi nodi nella tua rete sono attualmente offline. Si prega di ripristinare questi nodi per garantire il corretto funzionamento del sistema.`,
    team_support: 'Supporto del team',
    team_support_desc1: 'Probabile degrado nella cura!',
    team_support_desc2: 'Bisogno di miglioramento',
    team_support_desc3: 'Potrebbe essere meglio',
    team_support_desc4: 'Non ancora lì',
    team_support_desc5: 'Va bene, ma potrebbe essere meglio',
    team_support_desc6: 'Mostra promesse',
    team_support_desc7: 'Ha potenziale',
    team_support_desc8: 'Buon lavoro, punta alla perfezione!',
    team_support_desc9: 'Sforzo forte',
    team_support_desc10: 'Impressionante',
    team_support_desc11: 'Eccellente, non fermarti!',
    team_support_desc12: 'Fantastico, continua così!',
    team_support_desc13: 'Sforzo straordinario! Non fermarti',
    team_support_desc14: 'Eccezionale, continua così!',
    team_support_desc15: 'Straordinario, continua così!',
    insufficient_data_warning:
      'Dati insufficienti per fornire un feedback. In attesa che siano completati {count} cicli di pad.',
    demo_org_desc: 'Questa organizzazione sarà utilizzata a scopo dimostrativo',
    overall_evaluation: 'Valutazione complessiva',
    demonstration_mode: 'Modalità dimostrativa',
    responsiveness: 'Reattività',
    predicted_red: 'Rosso Previsto',
    predicted_mode: 'Modalità Prevista',
    predicted_time: 'Tempo previsto',
    display_time_in_dashboard: `Mostra l'ora nel cruscotto`,
    nurse_call_dashboard: 'Pannello chiamate infermiere',
    organisation_code: 'Codice organizzazione',
    generate_new: 'Genera nuovo',
    check_bin: 'Controlla il cestino',
    filter_module_selection_background_color:
      'Colore di sfondo della selezione del modulo filtro',
    filter_module_selection_text_color:
      'Colore del testo della selezione del modulo filtro',
    filter_module_label_color: "Colore dell'etichetta del modulo filtro",
    quick_action_icon_color: 'Colore dell’icona azione rapida',
    padding: 'Imbottitura',
    bottom: 'Inferiore',
    other: 'Altro',
    peel_and_apply: 'Stacca e applica',
    calibration_in_progress: 'Calibrazione in corso',
    apply_sensor: 'Applica sensore',
    apply_sensor_desc: 'In attesa che il sensore venga applicato',
    record_pod_change: 'Registrare il cambiamento del Pod',
    pod_change_history: 'Cronologia dei cambiamenti del Pod',
    change_date: 'Data del cambiamento',
    reason: 'Motivo',
    loggged_in_date: 'Data di accesso',
    check_connection_status: 'Controlla la connessione',
    check_connection_desc: 'In attesa della connessione del pod...',
    checking_connection: 'Verifica della connessione',
    max_sensor: 'Sensore Max',
    red_threshold: 'Soglia Rossa',
    loosely_connected_reclip_pod: 'Connessione allentata – Reclip Pod',
    loosely_connected: 'Connessione allentata',
    sensor: 'Sensore',
    embedded: 'Integrato',
    p_n_a: 'PnA',
    change_reason: 'Motivo della modifica',
    please_select_change_reason: 'Seleziona il motivo della modifica',
    feedback: 'Feedback',
    pad_weight: 'Peso di {pad}',
    export_pad_cycle_description:
      'Fai clic sul pulsante qui sotto per esportare i dati del ciclo {pad}',
    pad_weight_data_saved: 'Dati di peso di {pad} salvati:',
    pad_capacity_reached: 'Capacità di {pad} raggiunta',
    actual_weight: 'Peso effettivo',
    not_provided: 'Non fornito',
    pad_weight_first_question:
      'Il {pad} era abbastanza pieno da dover essere sostituito?',
    pad_weight_second_question: 'Hai un peso effettivo del pannolino?',
    actual_weight_provided: 'Peso effettivo fornito',
    leakages: 'Perdite',
    max_time_in_wet_pad: 'Tempo massimo in {pad} bagnato'
  },
  country: 'Italy',
  language: 'Italiano',
  abb_name: 'it'
}
